import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import React from 'react';

function HomeScreen() {

  return (
    <ContainerScreen hasBackground />
  );
}

export default HomeScreen;
